// extracted by mini-css-extract-plugin
export var banner = "_12-0";
export var icon = "_12-1";
export var message = "_12-2";